import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { variant } from 'styled-system'
import { useIntl } from 'react-intl'
import { useChat } from 'react-live-chat-loader'

import { Menu, MenuTrigger, MenuPopover, MenuLinks, MenuContent, MenuSection } from './Menu'
import { Flex, Box } from '../Grid'
import Text, { TextLink } from '../Type'
import { HelpOutlinedIcon } from '../Icon'

import useBreakpoint from '../../hooks/useBreakpoint'

const statusStyle = variant({ key: 'statusStyles', prop: 'variant' })
const indicatorStyle = variant({ key: 'indicatorStyles', prop: 'variant' })

const Indicator = styled.span`
  border-radius: 100%;
  display: inline-block;
  bottom: 2px;
  position: relative;
  height: 8px;
  width: 8px;
  ${indicatorStyle};
`

const HelpSection = styled(MenuSection)`
  ${statusStyle}
`

const Status = ({ active }) => {
  const [status, setStatus] = useState({
    indicator: 'none',
    description: 'All Systems Operational'
  })
  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch('https://kwpw55038gfh.statuspage.io/api/v2/status.json')
        const data = await response.json()
        setStatus(data.status)
      } catch (e) {
        setStatus({
          indicator: 'unknown',
          description: 'Error retrieving current status'
        })
      }
    }

    if (active) {
      fetchData()
    }
  }, [active])

  return (
    <HelpSection variant={status.indicator}>
      <Flex alignItems="center">
        <Box mr="8px">
          <Indicator variant={status.indicator} />
        </Box>
        <Box>
          <TextLink lineHeight={1} href="https://calibrestatus.com">
            Service Status
          </TextLink>
        </Box>
      </Flex>
      <Text level="xs" color="inherit">
        {status.description}
      </Text>
    </HelpSection>
  )
}

const HelpMenu = () => {
  const [isExpanded, setIsExpanded] = useState(false)
  const { formatMessage } = useIntl()
  const aboveMobile = useBreakpoint(0)
  const [, loadChat] = useChat()

  const MENU_LINKS = [
    {
      name: formatMessage({
        id: 'navigation.menu.help.gettingStarted.title'
      }),
      description: formatMessage({
        id: 'navigation.menu.help.gettingStarted.description'
      }),
      to: '/docs/get-started/guide',
      forceRefresh: true
    },
    {
      name: formatMessage({
        id: 'navigation.menu.help.docs.title'
      }),
      description: formatMessage({
        id: 'navigation.menu.help.docs.description'
      }),
      to: '/docs',
      forceRefresh: true
    },
    {
      name: formatMessage({
        id: 'navigation.menu.help.api.title'
      }),
      description: formatMessage({
        id: 'navigation.menu.help.api.description'
      }),
      to: '/docs/automation/node',
      forceRefresh: true
    },
    {
      name: formatMessage({
        id: 'navigation.menu.help.contact.title'
      }),
      description: formatMessage({
        id: 'navigation.menu.help.contact.description'
      }),
      to: '/contact',
      forceRefresh: true,
      onClick: event => {
        event.preventDefault()
        loadChat()
      }
    }
  ]

  return (
    <Menu onOpenChange={setIsExpanded}>
      <MenuTrigger className={isExpanded ? 'active' : ''} title={formatMessage({ id: 'navigation.links.docs' })}>
        <HelpOutlinedIcon width={22} height={22} />
      </MenuTrigger>
      <MenuPopover align="end">
        <MenuContent mobile={!aboveMobile} level="sm">
          <MenuSection sx={{ borderBottom: 'none' }}>
            <MenuLinks links={MENU_LINKS} maxHeight="100%" />
          </MenuSection>
          <Status active={isExpanded} />
        </MenuContent>
      </MenuPopover>
    </Menu>
  )
}

export default HelpMenu
